import React, {useEffect, useState} from "../../../__snowpack__/pkg/react.js";
import GnForm from "./index.js";
export default function FieldValidator(props) {
  const {name, verify, ...restProps} = props;
  return /* @__PURE__ */ React.createElement(GnForm.Item, {
    ...restProps,
    name,
    noStyle: true,
    rules: [
      {
        validator: (rule, value) => {
          return new Promise((resolve, reject) => {
            verify(value).then(() => {
              resolve("");
            }).catch(() => {
              reject("");
            });
          });
        }
      }
    ]
  }, /* @__PURE__ */ React.createElement(ValidatorMessage, {
    verify
  }));
}
const ValidatorMessage = (props) => {
  const {value, verify} = props;
  const [errorMessage, setErrorMessage] = useState();
  useEffect(() => {
    verify(value).then(() => {
      setErrorMessage(void 0);
    }).catch((error) => {
      setErrorMessage(error);
    });
  }, [value]);
  if (errorMessage) {
    return /* @__PURE__ */ React.createElement("div", {
      className: "ant-form-item-explain ant-form-item-explain-error"
    }, /* @__PURE__ */ React.createElement("div", {
      role: "alert"
    }, errorMessage));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null);
};
